import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import NearestForumBanner from "./NearestForumBanner";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-[var(--np-bg)]">
            <Header />
            <NearestForumBanner />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
